// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"29dac4fbefd27bc0","4661":"4ecf317cf4f9a6ed"}[chunkId] + ".css";
};